import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

type Props = {
  mode: "prev" | "next";
  chapterNum: string;
};

export const ChapterNavButton: FC<Props> = ({ mode, chapterNum }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const route = `/chapter/${parseInt(chapterNum) + (mode === "prev" ? -1 : 1)}`;

  const onClick = () => {
    navigate(route);
  };

  return (
    <button
      onClick={onClick}
      className="border-rust-50 border hover:bg-rust-10 text-rust-50 hover:text-rust-300 font-light py-1.5 sm:py-2 px-2 sm:px-4 rounded text-sm sm:text-base"
      type="button"
    >
      <p className="flex items-center text-sm sm:text-base">
        {mode === "prev" && (
          <ChevronLeftIcon className="h-4 w-4 sm:h-6 sm:w-6 mr-1 sm:mr-3" />
        )}
        <span className="inline">
          {mode === "prev"
            ? t("chapter.navButtons.previous")
            : t("chapter.navButtons.next")}
        </span>
        {mode === "next" && (
          <ChevronRightIcon className="h-4 w-4 sm:h-6 sm:w-6 ml-1 sm:ml-3" />
        )}
      </p>
    </button>
  );
};
